export const capitalizeFirst = (str?: string | null) => {
  if (!str) return "Not available";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
